import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { MapFlyToCenter } from "./MapFlyToCenter";
import { MapZoom } from "./MapZoom";
import { MapStreetView } from "./MapStreetView";
import { MapThreeDimensional } from "./MapThreeDimensional";
export const mapControlsContainerTestId = "cdp-map-controls-container";
export const MapControlsContainer = () => {
    return (_jsxs(Box, { position: "absolute", bottom: "spacing.32", right: "spacing.16", display: "flex", flexDirection: "column", gap: "spacing.8", alignItems: "center", testId: mapControlsContainerTestId, children: [_jsx(MapThreeDimensional, {}), _jsx(MapStreetView, { variant: "fullscreen" }), _jsx(MapZoom, {}), _jsx(MapFlyToCenter, {})] }));
};
